import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createAdmin, translateAuthError } from "../../api/authApi";

// Section C (admin-only): lets an existing admin provision another admin
// account, instead of the only way being ADMIN_USERNAME/ADMIN_PASSWORD at
// first startup (see backend/cmd/api/main.go's bootstrapAdmin).
function AdminNewAdminPage() {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("رمز عبور و تکرار آن یکسان نیستند.");
      return;
    }

    setSubmitting(true);
    try {
      await createAdmin(token, name, username, password);
      navigate("/admin");
    } catch (err) {
      setError(translateAuthError(err.message));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-page">
      <Link to="/admin" className="back-link">
        ← بازگشت به پنل مدیریت
      </Link>

      <form className="auth-card admin-article-form" onSubmit={handleSubmit}>
        <span className="corner corner-tr" />
        <span className="corner corner-tl" />
        <span className="corner corner-br" />
        <span className="corner corner-bl" />

        <h2>افزودن مدیر جدید</h2>

        {error && <p className="error">{error}</p>}

        <div className="auth-field">
          <label htmlFor="admin-name">نام</label>
          <input
            id="admin-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="name"
            required
          />
        </div>

        <div className="auth-field">
          <label htmlFor="admin-username">نام کاربری</label>
          <input
            id="admin-username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="auth-field">
          <label htmlFor="admin-password">رمز عبور</label>
          <input
            id="admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </div>

        <div className="auth-field">
          <label htmlFor="admin-confirm-password">تکرار رمز عبور</label>
          <input
            id="admin-confirm-password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </div>

        <button type="submit" className="auth-submit" disabled={submitting}>
          {submitting ? "در حال ایجاد..." : "ایجاد حساب مدیر"}
        </button>
      </form>
    </div>
  );
}

export default AdminNewAdminPage;
